import { useEffect } from "react";

export default function LcIntercomScripts() {
  useEffect(() => {
    window.intercomSettings = {
      app_id: "gip1n6e9",
    };

    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", w.intercomSettings);
    } else {
      const i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;

      if (!document.querySelector('script[src*="widget.intercom.io"]')) {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/gip1n6e9";
        document.head.appendChild(s);
      }
    }
  }, []);

  return null;
}
